let list = [];

for (let i = 0; i < 15; i++) {
    list.push({
        id: i + 1,
        applyOrgName: '济南 华美达酒店',
        applyUserName: '华美达',
        applyNum: 500,
        applyDate: '2019-12-12 12:22:22',
        state: '0',
        remark: '华美达初次制卡'
    });
}

export default {
    list,
    total: list.length,
    pageSize: 15,
    pageNum: 1
}



// WEBPACK FOOTER //
// ./src/configure/http/mock/response/operate/grant/queryByPage.js